import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ProvedorSessao } from './hooks/useSessao';
import { ProvedorTema } from './hooks/useTema';
import { LimiteDeErro } from './componentes/LimiteDeErro';
import './index.css';

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // O CD não muda a cada foco de janela; refetch automático aqui só
      // atrapalharia quem está com o mapa aberto.
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  },
});

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado no index.html.');

createRoot(raiz).render(
  <React.StrictMode>
    <LimiteDeErro>
      <QueryClientProvider client={cliente}>
        <ProvedorTema>
          <BrowserRouter>
            <ProvedorSessao>
              <App />
            </ProvedorSessao>
          </BrowserRouter>
        </ProvedorTema>
      </QueryClientProvider>
    </LimiteDeErro>
  </React.StrictMode>,
);
